import { useMemo } from "react";

import { Button, InfoPanel, Typography } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { FormCard } from "../FormControls/FormCard";

export interface SearchCardProps {
  children?: any;
  cardTitle?: string;
  hideDivider?: boolean;
  hideSearchBox?: boolean;
  textSuccess?: string;
  textError?: string;
  showSearch?: "disable" | "show";
  isFilterChanged?: boolean;
  onClickSearch?: (event: React.MouseEvent<any, MouseEvent>) => void;
  onClickClearSearch?: (event: React.MouseEvent<any, MouseEvent>) => void;
}

export const SearchCard = ({
  children,
  cardTitle,
  hideDivider,
  hideSearchBox,
  textSuccess = "",
  textError = "",
  showSearch,
  onClickSearch,
  onClickClearSearch,
  isFilterChanged,
}: SearchCardProps) => {
  const { t } = useTranslation();
  const renderDivider = useMemo(() => !hideDivider && <hr></hr>, [hideDivider]);
  const renderTextSuccess = useMemo(
    () =>
      textSuccess !== "" && (
        <InfoPanel fullWidth color="success" message="">
          {textSuccess}
        </InfoPanel>
      ),
    [textSuccess]
  );
  const renderTextError = useMemo(
    () =>
      textError !== "" && (
        <InfoPanel fullWidth color="danger" message="">
          {textError}
        </InfoPanel>
      ),
    [textError]
  );

  return (
    <>
      {!hideSearchBox && (
        <FormCard cardTitle={cardTitle}>
          {children}
          <Row>
            <Col md={6}></Col>
            <Col md={6}>
              {!!isFilterChanged && (
                <Typography
                  color="danger"
                  variant="smallBold"
                  className="text-right"
                >
                  <small>{t("common.filterChangedMessage")}</small>
                </Typography>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={3}></Col>
            <Col md={5}>
              {renderTextSuccess}
              {renderTextError}
            </Col>
            <Col md={1}></Col>
            <Col md={3}>
              <Button
                onClick={onClickSearch}
                size="sm"
                className="mr-2"
                disabled={
                  showSearch === "disable" ||
                  (isFilterChanged !== undefined && !isFilterChanged)
                }
              >
                {t("common.search")}
              </Button>
              <Button
                onClick={onClickClearSearch}
                outline={false}
                size="sm"
                boxless={true}
              >
                {t("common.clearFilters")}
              </Button>
            </Col>
          </Row>
        </FormCard>
      )}
      {renderDivider}
    </>
  );
};
